import { render, staticRenderFns } from "./WriteOffList.vue?vue&type=template&id=aafb90c2&scoped=true&"
import script from "./WriteOffList.vue?vue&type=script&lang=js&"
export * from "./WriteOffList.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffList.vue?vue&type=style&index=0&id=aafb90c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafb90c2",
  null
  
)

export default component.exports